// Firebase is temporarily disabled. Restore the original initialization when messaging is needed.
const app = null;
const analytics = null;
const messaging = null;

export { app, analytics, messaging };
